import { ConfigProvider } from 'tea-component';
import React from 'react';
import SelectMultiple from '@/pages/dashboard/components/SelectMultiple';
import { FormatOptionsParamsType } from '../../components/NewFilter/_type';
import Select from '@/pages/dashboard/components/Select';
import { LANGUAGE_CN } from '@/pages/dashboard/_config/constant';
import { importSvg } from '@/pages/dashboard/utils/utils';

import en_US from "tea-component/es/i18n/locale/en_US";
import zh_CN from "tea-component/es/i18n/locale/zh_CN";
import './filterList.scss';

const formatSourceOption = (config: FormatOptionsParamsType) => {
  const { options, valueKey, locale, cnKey = '', enKey = '', iconKey = '' } = config;
  return (options || []).map((item: any) => {
    const text = (locale === LANGUAGE_CN ? item?.[cnKey] : item?.[enKey]) || item?.[enKey] || item?.[cnKey];
    const value = item?.[valueKey];
    return {
      ...item,
      value,
      text,
      icon: item?.[iconKey] || importSvg(value),
    };
  });
};

const formatOptions: (option: FormatOptionsParamsType) => Array<any> = ({ options, valueKey, locale, cnKey = '', enKey = '', iconKey = '' }) => (options || [])?.filter((item: any) => item?.is_competitor).map((item: any) => {
  const text = (locale === LANGUAGE_CN ? item?.[cnKey] : item?.[enKey]) || item?.[enKey] || item?.[cnKey];
  return {
    ...item,
    value: item?.[valueKey],
    text,
    icon: item?.[iconKey],
  };
});

export const renderCompetitor = (props: any): React.ReactElement => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, ...restProps } = props || {};
  return <ConfigProvider locale={locale === 'en-US' ? en_US : zh_CN}>
    <SelectMultiple
      label={name || getLocalText('selector_multiple_component_competitor_label', {}, false)}
      allDescribe={getLocalText('selector_multiple_component_competitor_all_describe', {}, false)}
      // 此处使用解构赋值的方式解决初次渲染结果没有全选的问题
      className='search-item dbd-competitor-search-item'
      value={value}
      defaultValue={defaultValue}
      lastOneMessage={getLocalText('competitor_competitor_last_one_message', {}, false)}
      onChange={(value) => {
        onChange(key, value);
      }}
      options={formatOptions({
        options,
        locale,
        valueKey: 'unified_id',
        cnKey: 'name',
        enKey: 'name',
        iconKey: 'cover_url'
      })}
      {...restProps}
    />
  </ConfigProvider>;
};

export const renderSource = (props: any): React.ReactElement => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, ...restProps } = props || {};
  
  let formattedValue = value;
  if (Array.isArray(value)) {
    formattedValue = value[0];
  }

  return <Select
    label={name || getLocalText('competitor_source', {}, false)}
    className='search-item'
    value={formattedValue}
    defaultValue={defaultValue}
    options={formatSourceOption({
      options,
      locale,
      valueKey: 'value',
      cnKey: 'name',
      enKey: 'name',
    })}
    onChange={(value) => {
      onChange(key, value);
    }}
    {...restProps}
  />;
};
